import { gql } from 'graphql-tag';

export const GET_ASSET_PARTS = gql`
  query GetAssetParts($filter: AssetPartFilterInput) {
    assetParts(filter: $filter) {
      id
      assetId
      partId
      quantity
      createdAt
      updatedAt
      asset {
        id
        name
      }
      part {
        id
        name
        number
        currentStock
        isNotifyLowStock
        reorderPoint
        safetyStock
      }
    }
  }
`;

export const GET_ASSET_PART = gql`
  query GetAssetPart($id: ID!) {
    assetPart(id: $id) {
      id
      assetId
      partId
      quantity
      createdAt
      updatedAt
    }
  }
`;
